import { MenuButton } from '@reach/menu-button'
import styled from 'styled-components'
import css from '@styled-system/css'
import VisuallyHidden from '@reach/visually-hidden'

const Ingrediant = styled.div`
  ${css({
    bg: 'gray.4',
  })}
  border-radius: 25px;
  height: 4px;
  margin-right: 10px;
  margin-left: auto;
  width: 30px;

  transition: all 0.3s ease-in-out;
`

const TopBun = styled(Ingrediant)<{ changed: boolean }>`
  ${(props) => (props.changed ? `transform: rotate(45deg) ; transform-origin: 6px 12px;` : '')}
`
/* Fade out the second bar */
const Patty = styled(Ingrediant)<{ changed: boolean }>`
  margin-top: 4px;
  ${(props) => (props.changed ? `opacity: 0;` : '')}
`

const BottomBun = styled(Ingrediant)<{ changed: boolean }>`
  margin-top: 4px;
  ${(props) => (props.changed ? `transform: rotate(-45deg); transform-origin: 10px -6px; ` : '')}
`

/**
 * This is a  `MenuButton` from `@reach/menu-button` made to look like a hamburger.
 *
 * The `@reach/menu-button` makes sure menus are accessible to users with screen readers.
 */
const HamburgerButton = styled(({ isExpanded, className }) => (
  <MenuButton className={className}>
    <VisuallyHidden>{isExpanded ? 'Close' : 'Open'} Menu</VisuallyHidden>
    <TopBun changed={isExpanded} />
    <Patty changed={isExpanded} />
    <BottomBun changed={isExpanded} />
  </MenuButton>
))`
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  :hover > ${Ingrediant} {
    ${css({
      bg: 'gray.5',
    })}
  }
`

export default HamburgerButton
